export default [
    {
        date: 1584863802987,
        row: 14,
        col: 16,
        squares: [
            [5, 3, "#FF00FF"],
            [4, 4, "#FF00FF"],
            [3, 5, "#FF00FF"],
            [3, 6, "#FF00FF"],
            [4, 7, "#FF00FF"],
            [5, 8, "#FF00FF"],
            [5, 4, "#FF00FF"],
            [5, 5, "#FF00FF"],
            [5, 6, "#FF00FF"],
            [5, 7, "#FF00FF"],
            [4, 5, "#FF00FF"],
            [4, 6, "#FF00FF"],
            [5, 14, "#FF00FF"],
            [4, 13, "#FF00FF"],
            [3, 11, "#FF00FF"],
            [4, 10, "#FF00FF"],
            [5, 9, "#FF00FF"],
            [5, 10, "#FF00FF"],
            [5, 11, "#FF00FF"],
            [5, 12, "#FF00FF"],
            [5, 13, "#FF00FF"],
            [4, 12, "#FF00FF"],
            [4, 11, "#FF00FF"],
            [6, 2, "#FF00FF"],
            [7, 2, "#FF00FF"],
            [9, 2, "#FF00FF"],
            [8, 2, "#FF00FF"],
            [10, 2, "#000000"],
            [11, 2, "#FF00FF"],
            [12, 3, "#000000"],
            [6, 15, "#FF00FF"],
            [7, 15, "#FF00FF"],
            [9, 15, "#000000"],
            [8, 15, "#FF00FF"],
            [10, 15, "#FF00FF"],
            [11, 15, "#000000"],
            [12, 14, "#FF00FF"],
            [13, 4, "#FF00FF"],
            [13, 5, "#FF00FF"],
            [13, 6, "#FF00FF"],
            [13, 7, "#FF00FF"],
            [13, 8, "#FF00FF"],
            [13, 9, "#FF00FF"],
            [13, 10, "#FF00FF"],
            [13, 11, "#FF00FF"],
            [13, 12, "#FF00FF"],
            [13, 13, "#FF00FF"],
            [7, 4, "#00FFFF"],
            [7, 5, "#00FFFF"],
            [8, 6, "#00FFFF"],
            [9, 5, "#00FFFF"],
            [9, 4, "#00FFFF"],
            [8, 3, "#00FFFF"],
            [8, 4, "#CCCCCC"],
            [8, 5, "#CCCCCC"],
            [7, 13, "#00FFFF"],
            [7, 12, "#00FFFF"],
            [8, 14, "#00FFFF"],
            [9, 13, "#00FFFF"],
            [9, 12, "#00FFFF"],
            [8, 11, "#00FFFF"],
            [8, 12, "#CCCCCC"],
            [8, 13, "#CCCCCC"],
            [11, 6, "#000000"],
            [11, 7, "#000000"],
            [10, 8, "#000000"],
            [11, 9, "#000000"],
            [11, 10, "#000000"],
            [6, 3, "#FF00FF"],
            [7, 3, "#FF00FF"],
            [11, 8, "#FF0000"],
            [12, 8, "#FF0000"],
            [6, 4, "#FF00FF"],
            [6, 5, "#FF00FF"],
            [6, 6, "#FF00FF"],
            [7, 6, "#FF00FF"],
            [9, 6, "#FF00FF"],
            [10, 6, "#FF00FF"],
            [10, 5, "#FF00FF"],
            [10, 4, "#FF00FF"],
            [9, 3, "#FF00FF"],
            [10, 3, "#FF00FF"],
            [11, 3, "#000000"],
            [11, 4, "#FF00FF"],
            [11, 5, "#FF00FF"],
            [12, 5, "#FF00FF"],
            [12, 4, "#000000"],
            [12, 6, "#FF00FF"],
            [12, 7, "#FF00FF"],
            [10, 7, "#FF00FF"],
            [9, 7, "#FF00FF"],
            [8, 7, "#FF00FF"],
            [7, 7, "#FF00FF"],
            [6, 7, "#FF00FF"],
            [6, 8, "#FF00FF"],
            [7, 8, "#FF00FF"],
            [8, 8, "#FF00FF"],
            [9, 8, "#FF00FF"],
            [10, 9, "#FF00FF"],
            [8, 9, "#FF00FF"],
            [7, 9, "#FF00FF"],
            [6, 9, "#FF00FF"],
            [9, 9, "#FF00FF"],
            [12, 9, "#FF00FF"],
            [12, 10, "#FF00FF"],
            [12, 11, "#FF00FF"],
            [12, 12, "#FF00FF"],
            [12, 13, "#000000"],
            [11, 11, "#FF00FF"],
            [10, 11, "#FF00FF"],
            [9, 11, "#FF00FF"],
            [10, 10, "#FF00FF"],
            [9, 10, "#FF00FF"],
            [8, 10, "#FF00FF"],
            [7, 10, "#FF00FF"],
            [6, 10, "#FF00FF"],
            [6, 11, "#FF00FF"],
            [7, 11, "#FF00FF"],
            [6, 12, "#FF00FF"],
            [6, 14, "#FF00FF"],
            [6, 13, "#FF00FF"],
            [7, 14, "#FF00FF"],
            [9, 14, "#FF00FF"],
            [10, 14, "#000000"],
            [11, 14, "#000000"],
            [10, 13, "#FF00FF"],
            [11, 13, "#000000"],
            [10, 12, "#FF00FF"],
            [11, 12, "#FF00FF"],
            [8, 16, "#000000"],
            [11, 16, "#000000"],
            [13, 14, "#000000"],
            [14, 15, "#000000"],
            [14, 2, "#000000"],
            [13, 3, "#000000"],
            [12, 1, "#000000"],
            [12, 2, "#000000"],
            [9, 1, "#000000"],
            [3, 7, "#FFFF00"],
            [2, 8, "#FFFF00"],
            [2, 9, "#FFFF00"],
            [3, 10, "#FFFF00"],
            [4, 9, "#FFFF00"],
            [4, 8, "#FFFF00"],
            [3, 8, "#FFFF00"],
            [3, 9, "#FFFF00"],
            [3, 12, "#FF00FF"],
            [2, 13, "#FF00FF"],
            [1, 14, "#FF00FF"],
            [1, 15, "#FF00FF"],
            [2, 15, "#FF00FF"],
            [3, 15, "#FF00FF"],
            [4, 15, "#FF00FF"],
            [5, 15, "#FF00FF"],
            [2, 4, "#FF00FF"],
            [1, 3, "#FF00FF"],
            [1, 2, "#FF00FF"],
            [2, 2, "#FF00FF"],
            [3, 2, "#FF00FF"],
            [4, 2, "#FF00FF"],
            [5, 2, "#FF00FF"],
            [2, 3, "#CCCCCC"],
            [3, 3, "#CCCCCC"],
            [4, 3, "#CCCCCC"],
            [3, 4, "#CCCCCC"],
            [3, 13, "#CCCCCC"],
            [3, 14, "#CCCCCC"],
            [2, 14, "#CCCCCC"],
            [4, 14, "#CCCCCC"],
            [2, 7, "#FFFF00"],
            [1, 7, "#FFFF00"],
            [2, 10, "#FFFF00"],
            [1, 10, "#FFFF00"],
        ],
    },
];
